import { styled, Skeleton } from '@mui/material'

export const ThumbnailContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '90%',
  borderRadius: theme.shape.borderRadius / 2,
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const ThumbnailImage = styled('img')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: 1,
  transition: theme.transitions.create('opacity'),

  '&[data-loading="true"]': {
    opacity: 0,
  },
  '&[data-loading="false"]': {
    opacity: 1,
  },
}))

export const ThumbnailSkeleton = styled(Skeleton)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
})
